import {createSlice, isAnyOf, type SliceSelectors} from '@reduxjs/toolkit'
import {LOCATION_CHANGE} from 'redux-first-history'

import {merge} from '@shared/helpers/object'

import {restoreSavedState, restoreState} from '@web/actions/restoreState'
import {fetchWaitingState} from '@web/actions/waiting'
import {APIStatus} from '@web/core/constants'
import {
    checkInitOrderSheetDone,
    CommonState,
    getInitialState,
    getLanguage,
    getOrderSheetUrl,
    getSeqId,
    setBackUrl,
    setClosingTiming,
    setLanguage,
    setScene,
} from '@web/slices/common/slice'
import {LocationChangeAction} from '@web/slices/router'

import {CommonReducers, MakeCreateSliceOptions} from './interfaces'

export default (options?: MakeCreateSliceOptions) =>
    createSlice<CommonState, CommonReducers, 'common', SliceSelectors<CommonState>>({
        name: 'common',
        initialState: getInitialState(),
        reducers: {
            initialize(state, {payload}) {
                return merge(state, payload)
            },
        },
        extraReducers: (builder) => {
            // Try2: 페이지 위치 변경 시 seqID, channel 을 추출하여 저장합니다.
            builder
                .addCase(setScene, (state, {payload}) => {
                    state.scene = payload
                })
                .addCase<typeof LOCATION_CHANGE, LocationChangeAction>(LOCATION_CHANGE, (state) => {
                    state.seqID = getSeqId() || state.seqID
                    state.orderSheetUrl = getOrderSheetUrl()
                    state.language = getLanguage()
                })
                .addCase(checkInitOrderSheetDone, (state) => {
                    state.initOrderSheetDone = true
                })
                .addCase(setBackUrl, (state, {payload}) => {
                    state.backUrl = payload
                })
                .addCase(fetchWaitingState.fulfilled, (state, {payload}) => {
                    state.language = payload.languageCode ?? 'ko'
                })
                .addCase(setLanguage, (state, {payload}) => {
                    state.language = payload
                })
                .addCase(setClosingTiming, (state, {payload}) => {
                    state.closingTiming = payload
                })
            options?.extraReducers?.(builder)
            builder.addMatcher(isAnyOf(restoreSavedState.fulfilled, restoreState), (state, {payload}) => {
                return payload.common
                    ? {
                          ...payload?.common,
                          // 복구된 state는 이미 정보를 모두 가지고 있으므로 resolve 상태
                          scene: APIStatus.RESOLVED,
                      }
                    : state
            })
        },
    })
